import { useDropdownState } from '../abstract/dropdown';

export function useMaxFloorSizeFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: maxFloorSize, onSelect: onMaxFloorSizeSelect, options: maxFloorSizeOptions } = useDropdownState({
    defaultOptions: config.buildingSizeOptions,
    defaultValue: query.maxBuildingSize || config.maxBuildingSizeDefault,
    filterKey: `maxBuildingSize`,
    queryKey: `buildingm`,
    setFilters,
    updateQuery,
  });

  return { maxFloorSize, maxFloorSizeOptions, onMaxFloorSizeSelect };
}
